const loadPolyfills = async () => {
  if (window.IntersectionObserver === undefined) {
    await import("intersection-observer");
  }
};

export default loadPolyfills;
